// extracted by mini-css-extract-plugin
export default {"mainContainer":"StopRegister_mainContainer__-huhA"};